import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import Logo from '../common/Logo';

const Header = ({ setMobileMenuOpen }) => {
  return (
    <header className="h-16 border-b border-sp-gray-800 bg-sp-black/80 backdrop-blur-md sticky top-0 z-20 flex items-center justify-between px-4 md:px-6">
      <div className="flex items-center gap-4">
        <button 
          className="md:hidden text-gray-400 hover:text-white" 
          onClick={() => setMobileMenuOpen(true)}
        >
          <SafeIcon name="Menu" className="text-2xl" />
        </button>
        
        {/* Mobile Logo */}
        <div className="md:hidden flex items-center gap-2">
          <Logo className="w-6 h-6" />
          <span className="font-bold text-white tracking-tighter">SP</span>
        </div>

        <div className="hidden md:flex items-center bg-sp-gray-900 border border-sp-gray-700 rounded-md px-3 py-1.5 w-64 focus-within:border-sp-lime/50 focus-within:shadow-[0_0_10px_rgba(204,255,0,0.1)] transition-all">
          <SafeIcon name="Search" className="text-gray-500 mr-2" />
          <input 
            type="text" 
            placeholder="Search SKUs, POs..." 
            className="bg-transparent border-none outline-none text-sm text-gray-200 w-full font-mono placeholder-gray-600" 
          />
          <div className="flex items-center gap-1 ml-2">
            <kbd className="hidden lg:inline-block text-[10px] bg-sp-gray-800 text-gray-400 px-1.5 py-0.5 rounded border border-sp-gray-700 font-mono">⌘</kbd>
            <kbd className="hidden lg:inline-block text-[10px] bg-sp-gray-800 text-gray-400 px-1.5 py-0.5 rounded border border-sp-gray-700 font-mono">K</kbd>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4 md:gap-6">
        <div className="flex items-center gap-4">
          <button className="relative text-gray-400 hover:text-white transition-colors group">
            <SafeIcon name="Bell" className="text-xl" />
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-sp-alert rounded-full border-2 border-sp-black shadow-neon-alert group-hover:scale-110 transition-transform"></span>
          </button>
          <button className="text-gray-400 hover:text-white transition-colors">
            <SafeIcon name="Settings" className="text-xl" />
          </button>
        </div>
        
        <div className="h-6 w-px bg-sp-gray-800"></div>
        
        <div className="flex items-center gap-3 cursor-pointer group">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-medium text-gray-200 group-hover:text-white">Op. Alpha</div>
            <div className="text-[10px] text-sp-lime font-mono">ADMIN_ROLE</div>
          </div>
          <div className="w-9 h-9 rounded-md bg-sp-gray-800 border border-sp-gray-700 flex items-center justify-center overflow-hidden group-hover:border-sp-lime/50 transition-colors">
            <img 
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=100&h=100&q=80" 
              alt="User" 
              className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all" 
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;